import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import PathsConfig from '../../../Config/RoutePaths';
import { esAptoParaBaja } from '../../../Filter/solicitudBaja';
import { canPago, findPlanForSuscription, isPinNYT, canReclamarEditorial, esAptoUpselling } from '../../../Filter/suscripciones';
import UrlProperties from '../../../Helpers/UrlProperties';
import useObtenerPlanes from '../../../Hooks/useObtenerPlanes';
import useObtenerSuscripciones from '../../../Hooks/useObtenerSuscripciones';
import useSuscripcionesConEstado from '../../../Hooks/useSuscripcionesConEstado';
import Embed from '../../../Models/Embed';
import estadoSuscripciones from '../../../Models/EstadoSuscripciones';
import ConfigUpselling  from '../../../Config/UpsellingConfig'
import useObtenerPinUsuario from '../../../Hooks/useObtenerPinUsuario';

const useGetPlanesYsuscripciones = () => {
    const [error, setError] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [suscripcionesHook, setsuscripcionesHook] = useState([]);
    const [planesHook, setplanesHook] = useState([]);
    const [planes, errorPlanes, isLoadingPlanes] = useObtenerPlanes();
    const [suscripciones, errorSuscripciones, isLoadingSuscripciones] = useObtenerSuscripciones();
    const [suscripcionesConEstado, errorSuscripcionesConEstado, isLoadingSuscripcionesConEstado] = useSuscripcionesConEstado();
    const [suscriptionLinks, setsuscriptionLinks] = useState();
    const historyRouter = useHistory();
    const [esApta, setEsApta] = useState(true);
	const [dataPin, errorPin, isLoadingPin] = useObtenerPinUsuario();

	useEffect(() => {
		
        if (!isLoadingPlanes && !isLoadingSuscripciones && !isLoadingSuscripcionesConEstado && !isLoadingPin) {
            setsuscripcionesHook(suscripciones);
            setplanesHook(planes);
            setsuscriptionLinks(suscripciones?.map((sus) => listDropCreator(sus, planes)));
            setIsLoading(false);
            if (errorPlanes || (errorSuscripcionesConEstado && !suscripcionesConEstado) || (errorSuscripciones && !suscripciones)) {
                setError(true);
            }
        }
    }, [isLoadingPlanes, isLoadingSuscripciones, isLoadingSuscripcionesConEstado, isLoadingPin]);

    const handlerSolicitarBaja = (id) => {
        const filteredSuscription = suscripcionesConEstado.filter((suscripcion) => suscripcion.IdSuscripcion === id);
        if (!esAptoParaBaja(...filteredSuscription)) {
            setEsApta(false);
        } else {
            historyRouter.push({ pathname: PathsConfig.SolicitudBaja + `/${id}`, state: { susId: id } });
        }
    };

    const listDropCreator = (sus, planes) => {
        let links = [];

        if (sus.Estado === estadoSuscripciones.BAJA) {
            return null;
        }

		if (sus.EsGoogle) {
			links.push({
				name: 'Administrar a través de Google',
				onClick: () => window.open(!Embed ? `${process.env.REACT_APP_PAYMENTGOOGLE}` : '', '_blank'),
			});
		}
		if (sus.EsApple) {
			links.push({
				name: 'Administrar a través de Apple',
				onClick: () => window.open(!Embed ? `${process.env.REACT_APP_PAYMENTAPPLE}` : '', '_blank'),
			});
		}
		if (findPlanForSuscription(sus, planes)) {
			links.push({
				name: 'Leer PDF',
				onClick: () => window.open(!Embed ? 'https://pdf.lanacion.com.ar' : '', '_blank'),
			});
		}
		if (isPinNYT(sus, planes)) {
			links.push({
				name: `Leer ${dataPin && dataPin.descripcion}`,
				onClick: () => window.open(!Embed ? 'http://www.nytimes.com/' : '', '_blank'),
			});
		}
		if (canPago(sus, planes)) {
			links.push(
				{ name: 'Cambiar forma de pago', onClick: () => (location.href = `${process.env.REACT_APP_MICUENTA}cambiar-forma-de-pago`) },
				{ name: 'Solicitar baja', onClick: () => handlerSolicitarBaja(sus.Id) }
			);
		}
		if (canReclamarEditorial(sus, planes)) {
			links.push({
				name: 'Reclamo de entrega',
				onClick: () => {
					historyRouter.push({
						pathname: PathsConfig.ReclamoEntrega,
						state: {
							suscripcionSeleccionado: sus,
						},
					});
				},
			});
		}
		if (esAptoUpselling(sus, planes) && !sus.payment) {
			const IdCanalDeVenta = UrlProperties.getParam('cv');
			const IdFormaDeContacto = UrlProperties.getParam('fc');
			ConfigUpselling.campania.planes.map(plan =>
				links.push(
					{
						name: `Actualizar a ${plan[Object.keys(plan)].nombre}`,
						//onClick: () => location.href = `${process.env.REACT_APP_MICUENTA}confirmar-upselling/${plan.campaniaKey}/${plan.planKey}`
						onClick: () => historyRouter.push({
							pathname: `${PathsConfig.UpsellingConfirmar}/${ConfigUpselling.campania.key}/${Object.keys(plan)}`,
							search: `${IdCanalDeVenta ? `?cv=${IdCanalDeVenta}` : ''}${IdFormaDeContacto ? `&fc=${IdFormaDeContacto}` : ''}`,
						})
					}
				)
			);
		};
        

        if (!links.length) {
            return null;
        } else {
            return links;
        }
    };

    return [planesHook, suscripcionesHook, suscriptionLinks, esApta, setEsApta, isLoading, error, dataPin, errorPin];
};

export default useGetPlanesYsuscripciones;
